<template>
  <card :class="{'oculto' : obra.oculto}">
    <div class="header" v-if="type == 'full'">
      <h4 class="title">{{obra.titulo}}</h4>
      <div v-if="obra.subtitulo">{{obra.subtitulo}}</div>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-md-9 col-12">
          <div v-if="type !== 'full'">
            <strong>Livro:
              <router-link class="normal-link" :to="{ path: `/book/${obra.id}`}">{{obra.titulo}}</router-link>
            </strong>
            <div v-if="obra.subtitulo">
              <small>{{obra.subtitulo}}</small>
            </div>
          </div>
          <div>
            <strong>Autor:</strong>
            <span v-if="!obra.autores.length">-</span>
            <span class="nome-autor" v-for="(autor,index) in obra.autores" :key="`author-${index}`">{{autor.nome_autor}}</span>
          </div>
          <div>
            <strong>Código:</strong>
            <span>{{obra.codigo}}</span>
          </div>
          <div>
            <strong>Categoria:</strong>
            <span>{{obra.categoria.nome_categoria}}</span>
          </div>
          <template v-if="type === 'full'">
            <div v-if="obra.colecao">
              <strong>Coleção:</strong>
              <span>{{obra.colecao.nome_colecao}}</span>
            </div>
            <div v-if="obra.editora">
              <strong>Editora:</strong>
              <span>{{obra.editora.nome_editora}}</span>
            </div>
            <div v-if="obra.ano">
              <strong>Ano:</strong>
              <span>{{obra.ano}}</span>
            </div>
            <div v-if="obra.idioma_id">
              <strong>Idioma:</strong>
              <span v-if="obra.idioma_id === 1">Português</span>
              <span v-if="obra.idioma_id === 2">Inglês</span>
              <span v-if="obra.idioma_id === 3">Espanhol</span>
            </div>
            <div v-if="obra.midia_id">
              <strong>Tipo de Mídia:</strong>
              <span v-if="obra.midia_id === 1">Livro</span>
              <span v-if="obra.midia_id === 2">Livreto</span>
              <span v-if="obra.midia_id === 3">Periódico</span>
              <span v-if="obra.midia_id === 4">DVD</span>
            </div>
            <div v-if="obra.edicao">
              <strong>Edição:</strong>
              <span>{{obra.edicao}}</span>
            </div>
            <div v-if="obra.volume">
              <strong>Volume:</strong>
              <span>{{obra.volume}}</span>
            </div>
            <div v-if="obra.paginas">
              <strong>Páginas:</strong>
              <span>{{obra.paginas}}</span>
            </div>
            <div v-if="obra.sinopse">
              <strong>Sinopse:</strong>
              <blockquote class='sinope' v-html='sinopseHTML'></blockquote>
            </div>
          </template>
          <div>
            <span
              v-for="(tag,index) in obra.tags"
              :key="`tag-${index}`"
              @click="filterByTagEvt(tag.id)"
              class="badge badge-info tag"
            >{{tag.nome_tag}}</span>
          </div>
          <div>
            <span
              class="badge badge-danger"
              v-if="!obra.items.length"
              title="Sem itens disponíveis"
            >Não disponível</span>
            <span
              class="badge badge-warning"
              v-if="restritos.length && isAdmin"
              title="Itens disponíveis">Possui Itens Restritos</span>
            <span
              class="badge badge-warning"
              v-if="obra.emprestimos.length >= obra.items.length"
              title="Emprestado"
            >Emprestado</span>
            <span class="badge badge-primary" v-if="obra.reservas.length" title="Reservado">Reservado</span>
          </div>
          <div v-if="obra.motivo_indisponivel && isAdmin">
            <strong>Motivo Indisponível:</strong>
            <span>{{obra.motivo_indisponivel}}</span>
          </div>
        </div>
        <div class="col-md-3 col-12">
          <router-link
            v-if="type !== 'full'"
            class="btn btn-block btn-info"
            :to="{ path: `/book/${obra.id}`}"
          >Detalhes</router-link>
          <template v-if="isAdmin">
            <router-link
              class="btn btn-block btn-outline-info"
              :to="{ path:  `/editBook/${obra.id}`}"
            >Editar</router-link>
            <button
              v-if="!obra.oculto"
              :class="{'btn-default': !obra.recomendado, 'btn-success': obra.recomendado}"
              @click="recomendar(obra)"
              class="btn btn-block btn-default btn-recomendar"
              title="Recomendar"
            >
              <i class="ti-star"></i>
            </button>
            <router-link
              v-if="!obra.oculto && obra.disponivel"
              class="btn btn-block btn-warning"
              :to="{ path:  `/novoEmprestimo/${obra.id}`}"
            >Emprestar</router-link>
            <router-link
              v-if="!obra.oculto && !obra.disponivel"
              class="btn btn-block btn-outline-warning"
              :to="{ path:  `/novaReserva/${obra.id}`}"
            >Reservar</router-link>
          </template>
        </div>
      </div>
    </div>

  </card>
</template>
<script>
import { Editor } from 'tiptap'
import { mapGetters } from 'vuex'

export default {
  props: {
    obra: Object,
    type: String
  },
  data () {
    return {
      editor: undefined,
      sinopseHTML: undefined,
      content: undefined
    }
  },
  computed: {
    ...mapGetters(['isAdmin']),
    restritos() {
      return this.obra.items.filter(item => item.restrito)
    }
  },
  methods: {
    filterByTagEvt(tagId) {
      this.$emit('tag', tagId)
    },
    recomendar() {
      this.$emit('recomendar', this.obra)
    }
  },
  mounted () {
    if (this.obra.sinopse) {
      try {
        this.content = JSON.parse(this.obra.sinopse)
      } catch (error) {
        this.content = {
          type: 'doc',
          content: [{
            type: 'paragraph',
            content: [
              {
                type: 'text',
                text: this.obra.sinopse
              }
            ]
          }]
        }

        if (!this.obra.sinopse) {
          this.content.content[0].content = []
        }
      }

      this.editor = new Editor({
        onUpdate: ({ getHTML }) => {
          this.sinopseHTML = getHTML()
        }
      })

      this.editor.setContent(this.content, true)
    }
  },
  beforeDestroy () {
    if (this.editor) {
      this.editor.destroy()
    }
  }
}
</script>

<style scoped>
.strike .data {
  text-decoration: line-through;
}

.nome-autor {
  margin-left: 2px;
}

.nome-autor:after {
  content: ",";
}

.nome-autor:last-of-type:after {
  content: none;
}

.tag {
  cursor: pointer;
  margin-right: 5px;
}

.btn-recomendar {
  margin-top: 5px;
}
.oculto {
  background-color: lightcoral;
  color: white;
}

.normal-link {
  color: #252422;
}

div > strong + span {
  margin-left: 2px;
}

.sinope {
  text-align: justify;
}

.sinope >>> p {
  text-indent: 20px;
}
</style>
